import { useEffect, useRef, useState } from "react";
const slides = [
  {
    emoji: "🤝",
    title: "Find Your Fit Friend",
    meta: "Match by goals & schedule",
    text: "Connect with people who share your energy, pace, and fitness style."
  },
  {
    emoji: "🏃‍♀️",
    title: "Group Runs Near You",
    meta: "Mornings • Local trail",
    text: "Meet friendly runners, stay consistent, and enjoy post-run hangs."
  },
  {
    emoji: "🧘",
    title: "Chill Yoga Sessions",
    meta: "Evenings • Parks & gyms",
    text: "Join low-pressure, beginner-friendly yoga groups in your area."
  },
  {
    emoji: "🏋️",
    title: "Gym Accountability",
    meta: "Anytime • Your gym",
    text: "Find someone who actually shows up, pushes you, and hypes your PRs."
  },
  {
    emoji: "🚴",
    title: "Weekend Rides",
    meta: "Sat 7 AM • Coastal route",
    text: "Cyclists of all levels welcome • social pace • good vibes only."
  },
  {
    emoji: "✨",
    title: "A Supportive Community",
    meta: "Safety first • Positive vibes",
    text: "BeFitFriends is built to help you feel comfortable meeting new people."
  },
];

export default function ActivitySlider() {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % slides.length), 7000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!trackRef.current) return;
    trackRef.current.scrollTo({
      left: trackRef.current.clientWidth * index,
      behavior: "smooth",
    });
  }, [index]);

  return (
    <section style={{ padding: "2.5rem 0" }}>
      <h2
        style={{
          fontSize: "1.4rem",
          marginBottom: ".5rem",
          textAlign: "center",
        }}
      >
        What you can do with BeFitFriends
      </h2>

      <p
        className="activity-lead"
        style={{
          textAlign: "center",
          maxWidth: "600px",
          margin: "0 auto 1.5rem",
          opacity: 0.85,
        }}
      >
        Discover local activities, meet people who match your vibe, and stay
        motivated with a supportive fitness community.
      </p>

      {/* FULL-WIDTH SLIDER FIX */}
      <div
        className="slider"
        style={{
          width: "100%",
        }}
      >
        <div
          className="slider-track"
          ref={trackRef}
          style={{
            display: "flex",
            overflowX: "scroll",
            scrollSnapType: "x mandatory",
          }}
        >
          {slides.map((s, i) => (
            <article
              key={i}
              style={{
                width: "100%",
                flexShrink: 0,
                scrollSnapAlign: "center",
                display: "flex",
                justifyContent: "center",
                padding: "2rem 0",
              }}
            >
              {/* CENTER BOX CARD */}
              <div
                style={{
                  background: "var(--surface, #f3f5f6)",
                  padding: "1.5rem",
                  borderRadius: "1rem",
                  maxWidth: "320px",
                  width: "90%",
                  textAlign: "center",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
              >
                <div style={{ fontSize: "2rem", marginBottom: ".5rem" }}>
                  {s.emoji}
                </div>

                <div style={{ fontSize: "1.25rem", fontWeight: 600 }}>
                  {s.title}
                </div>

                <div
                  style={{
                    fontSize: ".9rem",
                    marginTop: ".25rem",
                    opacity: 0.7,
                  }}
                >
                  {s.meta}
                </div>

                <div
                  style={{
                    marginTop: ".75rem",
                    fontSize: "1rem",
                    lineHeight: 1.4,
                  }}
                >
                  {s.text}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div
          className="slider-dots"
          style={{
            display: "flex",
            gap: ".4rem",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                border: "none",
                background: i === index ? "#1f2e36" : "#d0d4d8",
                transition: "0.2s",
                cursor: "pointer",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
